import Icon from '@/components/atoms/Icon'
import Button from '@/components/atoms/Button'

type ScrollDownProps = {
  targetRef: React.RefObject<HTMLDivElement | null>
}

const ScrollDown = ({ targetRef }: ScrollDownProps) => {
  const onClick = () => {
    const rect = targetRef.current?.getBoundingClientRect()
    if (!rect) return

    window.scrollTo({
      top: rect.height,
      behavior: 'smooth',
    })
  }

  return (
    <Button
      theme='dark'
      autoWidth
      aria-label='Scroll down'
      onClick={onClick}
      Icon={() => <Icon iconName='ArrowDown' />}
    />
  )
}

export default ScrollDown
